<template>
  <div class="project get-clean">
    <project-header :project="project"></project-header> 

    <div class="project-gallery row">
      <div class="col-12 get-clean__dirty-truth">
      <video class="no-scrollplay" poster="/static/images/get-clean/poster.jpg" playsinline controls @click="$event.target.paused ? $event.target.play() : $event.target.pause()">
        <source src="/static/videos/get-clean/dirty_truth_video.mp4">
      </video>
      </div>
      <div class="col-12 project-gallery__img" v-for="image in identity" :key="image">
        <img class="project-gallery__image" :src="`/static/images/get-clean/${image}`">
      </div>
      <div class="col-12 project-gallery__fullsize-video project-gallery__double-video">
        <div class="video-fix">
          <video class="project-gallery__video col-12" playsinline muted loop>
            <source src="/static/videos/get-clean/get-clean-logo-gif.mp4">
          </video>
        </div>
        <div class="video-fix">
          <video class="project-gallery__video col-12" playsinline muted loop>
            <source src="/static/videos/get-clean/get-clean-splash-gif.mp4">
          </video>
        </div>
      </div>
      <img src="/static/images/get-clean/get-clean-icons-left.svg" class="col-10 col-6-md col-5-lg project-gallery__icons">
      <img src="/static/images/get-clean/get-clean-icons-right.svg" class="col-10 col-6-md col-5-lg project-gallery__icons project-gallery__icons--last">
      <div class="col-12 project-gallery__img" v-for="image in process" :key="image">
        <img class="project-gallery__image" :src="`/static/images/get-clean/${image}`">
      </div>
      <div class="col-12 ta-center video-fix get-clean__products">
        <div>
        <video class="project-gallery__fullsize-video" playsinline muted loop>
          <source src="/static/videos/get-clean/products-gif.mp4">
        </video>
        </div>
      </div>
      <div class="col-12 project-gallery__img" v-for="image in packaging" :key="image">
        <img class="project-gallery__image" :src="`/static/images/get-clean/${image}`">
      </div>
      <div class="col-12 project-gallery__img" v-for="image in products" :key="image">
        <img class="project-gallery__image" :src="`/static/images/get-clean/${image}`">
      </div>
      <div class="col-12 get-clean__robobs">
        <video autoplay muted playsinline loop>
          <source src="/static/videos/get-clean/dance.mp4"></source>
        </video>
        <video autoplay muted playsinline loop>
          <source src="/static/videos/get-clean/snow-angel.mp4"></source>
        </video>
        <video autoplay muted playsinline loop>
          <source src="/static/videos/get-clean/r2d2.mp4"></source>
        </video>
      </div>
      <div class="col-12 project-gallery__img" v-for="image in promo" :key="image">
        <img class="project-gallery__image" :src="`/static/images/get-clean/${image}`">
      </div>
       <div class="col-12 project-gallery__video-container">
        <website-video :sources="['/static/videos/get-clean/getclean-web-index-scroll-desktop.mp4']"></website-video>
      </div>
      <div class="col-12 project-gallery__video-container">
        <website-video :sources="['/static/videos/get-clean/get-clean-scroll-mobile.mp4']" :portrait="true"></website-video>
      </div>
    </div>

    <project-footer prev="/work/clean-sound" next="/work/incbues"></project-footer>
  </div>
</template>

<script>
import project from '../../mixins/project'
import automaticallyPlayVideo from '../../mixins/automaticallyPlayVideo'
import projects from '../../projects'
import WebsiteVideo from '../WebsiteVideo.vue'

export default {
  name: 'get-clean',
  data () {
    return {
      project: projects.find(project => project.title === 'Get Clean'),
      identity: [
        'products-family.jpg',
        'get-clean-logo-3.jpg',
        'colours.jpg'
      ],
      process: [
        'get-clean-process.jpg'
      ],
      promo: [
        'get-clean-illustrations-1.jpg',
        'get-clean-illustrations-2.jpg',
        'card-together-1.jpg',
        'tote-1.jpg',
        't-shirts-1.jpg',
        'brochure-2.jpg',
        'outdoor-1.jpg'
      ],
      products: [
        'get-clean-tower-stack.jpg'
      ],
      packaging: [
        'get-clean-hanger.jpg',
        'get-clean-displays.jpg'
      ]
    }
  },
  components: {
    WebsiteVideo
  },
  mixins: [
    project,
    automaticallyPlayVideo
  ]
}
</script>

<style lang="sass">

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

.get-clean
  .project-gallery__fullsize-video
    margin-top: 50px
    height: 100%

  .project-gallery__video
    box-shadow: none
    background: white

.get-clean__dirty-truth
  margin-bottom: 50px
  position: relative
  video
    width: 100%
    height: 100%
    &::-webkit-media-controls-start-playback-button
      display: none !important
      -webkit-appearance: none

.get-clean__products
  video
    max-width: 500px

.get-clean__robobs
  display: flex
  flex-direction: column
  justify-content: flex-start
  margin-bottom: 50px
  +small
    align-items: flex-start
    flex-direction: row
    justify-content: space-between
  video
    width: 100%
    margin-bottom: 24px
    +small
      width: calc(100% / 3 - 20px)

.project-gallery__video--medium
  width: 100%
  height: 100%
  +medium
    max-height: 400px

.get-clean
  .project-gallery__video--medium
    margin-top: 0
    +medium
      max-height: 601px

.project-gallery__double-video
  display: flex
  flex-wrap: wrap
  .video-fix
    width: auto

.get-clean
  .project-gallery__double-video
    justify-content: space-around
    margin-top: 0
    margin-bottom: 25px
    video
      +medium
        max-height: 350px
        max-width: 350px

.get-clean
  .project-gallery__gifs
    display: flex
    justify-content: space-between
    flex-direction: column
    video
      margin-top: 0
    +medium
      flex-direction: column

.project-gallery__icons
  margin-left: auto
  height: 100%
  max-width: 400px
  &--last
    margin-top: 0
    margin-bottom: 50px
    margin-left: 0
    margin-right: auto
  +medium(max)
    margin-right: auto
  +medium
    margin-bottom: 75px

</style>



// WEBPACK FOOTER //
// GetClean.vue?8f2f0d84